import { Component, input, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'ol-widget-container',
  templateUrl: './widget-container.component.html',
  styleUrls: ['./widget-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, RouterLink],
})
export class WidgetContainerComponent {
  title = input<string>('');
  headerLink = input<string>('');
  headerActionTemplate = input<TemplateRef<unknown> | null>(null);
}
